import React from 'react'
import { useContentful, getVariantContent } from '@pcln/contentful-components'
import MARKETING_TOUT from '@/constants/promotions/marketing-tout'
import useSeti from '@/hooks/useSeti'
import GenericBanner from '../../GenericBanner'
import MerchModuleWrapper from '../../MerchModuleWrapper'

export default function MarketingTout() {
  const marketingTout: any = useContentful('marketingTout')
  const setiName = useSeti(
    marketingTout?.experimentName,
    marketingTout?.experimentName !== undefined
  )

  const marketingToutData = marketingTout?.experimentName
    ? getVariantContent(setiName, marketingTout)
    : marketingTout

  return marketingTout != null ? (
    <MerchModuleWrapper {...marketingToutData} />
  ) : (
    <GenericBanner content={MARKETING_TOUT} />
  )
}
